import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "../../../components/core/Button";
import LavorisService from "../../../services/LavorisService";
import StyledWrapper from "./style";
import { RequestCoords } from "../../../services/DangerZones/DangerZones.type";
import { FranchiseLogo } from "../../../components/others/FranchiseBranding";



function RemoteLinkConfirmation() {
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [done, setDone] = useState(false)
    const { id } = useParams()

    const LavorisInstance = LavorisService.getInstance();
    const getCoordinates = async (): Promise<GeolocationPosition> => {
        return new Promise((res, rej) => {
            navigator.geolocation.getCurrentPosition(res, rej)
        })
    };


    const postCoordinates = async (coordinates: any) => {
        try {
            if (!id || !coordinates) return console.log('error en obtener el id o las coordenadas');
            await LavorisInstance.RemoteGoogleLink.postPacientCoordinates(id, coordinates);
            setLoading(false);
            setDone(true);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    const getPosition = async () => {
        try {
            setError(false);
            const position = await getCoordinates();
            if (!position) return console.log('error en obtener las coordenadas');
            const coordinates = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            }
            setLoading(true);
            postCoordinates({coordinates});
         } catch (error) {
            console.log(error);
            if (error) {
                setError(true);
                setLoading(false);
            }
        }
    }


    return (
        <div className="h-screen bg-[#525151]">
            <StyledWrapper.Header>
                <div className="ml-5 mt-9 flex justify-center items-center">
                    <FranchiseLogo className="logo" linkToHome={false} />
                </div>
            </StyledWrapper.Header>

            <StyledWrapper.Card>

                {!done && (

                    error ? (
                        <>
                            <StyledWrapper.CardTitle>
                                Ha denegado la ubicación
                            </StyledWrapper.CardTitle>
                            <StyledWrapper.CardSpan>
                                Debe actualizar los permisos de su navegador yendo a la configuración del mismo, una vez hecho esto puede volver a hacer click en el botón.
                            </StyledWrapper.CardSpan>
                        </>

                    ) :
                        (<> <StyledWrapper.CardTitle>
                            Acepta los permisos de ubicación, micrófono y cámara
                        </StyledWrapper.CardTitle>
                            <StyledWrapper.CardSpan>
                                Es necesario para poder comunicarte correctamente con el profesional
                            </StyledWrapper.CardSpan>
                        </>)
                )}


                {!done ?
                    (<Button className={"bg-[#DF6865] py-2  border-2 rounded-md text-white"}
                        onClick={getPosition}
                        type='button'
                        text='Acceptar permisos'
                        disabled={loading}
                    />) :
                    <>
                        <StyledWrapper.CardTitle>
                            Muchas gracias por aceptar los permisos.
                        </StyledWrapper.CardTitle> <br />
                        <span className="mt-3 text-md text-[#888888]">En los próximos minutos el médico le enviará el link para poder realizar la videollamada</span>
                    </>
                }



            </StyledWrapper.Card>


        </div>
    )
}

export default RemoteLinkConfirmation